import {Component, Input} from '@angular/core';
import {License} from '@twpub/shared/services/about/about.service';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';

@Component({
  selector: 'pub-license-display',
  templateUrl: './license-display.component.html',
  styleUrls: ['./license-display.component.scss'],
  standalone: true,
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle]
})
export class LicenseDisplayComponent {
  @Input() licenses: License[] | undefined;
}
